// extracted by mini-css-extract-plugin
module.exports = {"promoLink":"PromoLink_promoLink__2EC4v","container":"PromoLink_container__zCb_o","divider":"PromoLink_divider__1bdad"};